import React, { Component } from 'react'
import Projectdetail from './Projectdetail'
import Imagerow from './components/Imagerow'
import Updates from './components/Projupdates'

export class arthurcashorig extends Component {

  render() {


    return (
      <React.Fragment>
        <Projectdetail
          image="assets/img/screenshots/lrg/contact.jpg"
          heading="The Practice of Arthur E. Cash"
          content={[
            <>
              <p>
                The Practice of Arthur E. Cash, LICSW and Associates, is a
                Mental Health center that has been providing behavioral health
                therapeutic services in Western Massachusetts and Connecticut
                for 40 years. I was asked by Mr. Arthur Cash to design and
                implement a website to help introduce, and market his services
                to a wider audience.
              </p>

              <p>
                Visitors to the site can get an in-depth look at their
                background, and history in the field of Mental Health and look
                at the services, seminars, and workshops that they offer. Since
                it original creation a few years, the site has recently been
                fully redesigned to a more modern look and feel.
              </p>
            </>,
          ]}
          website="http://www.thepracticeofarthurecash.com"
          github=""
          techs={[
            <>
              <li>Html</li>
              <li>CSS</li>
              <li>JavaScript</li>
            </>,
          ]}
          updates={[
            <>
              <h2 className="heading-2">Recent Updates</h2>

              <div className="updates">
                <Updates
                  heading="UPDATE 6/20/2020"
                  desc={[
                    <>
                      <p>
                        I recently did a complete redesign to the site to give
                        it a cleaner modern look and feel.
                      </p>
                    </>,
                  ]}
                  itemImage={[
                    {
                      fullimage: "assets/img/screenshots/lrg/header.jpg",
                      screenshot: "assets/img/screenshots/lrg/header.jpg",
                    },
                    {
                      fullimage: "assets/img/screenshots/lrg/meettheteam.jpg",
                      screenshot: "assets/img/screenshots/lrg/meettheteam.jpg",
                    },
                    {
                      fullimage:
                        "assets/img/screenshots/lrg/featuredarticles-hover.jpg",
                      screenshot:
                        "assets/img/screenshots/lrg/featuredarticles-hover.jpg",
                    },
                    {
                      fullimage: "assets/img/screenshots/lrg/article-head.jpg",
                      screenshot: "assets/img/screenshots/lrg/article-head.jpg",
                    },
                    {
                      fullimage: "assets/img/screenshots/lrg/t345t34t.jpg",
                      screenshot: "assets/img/screenshots/lrg/t345t34t.jpg",
                    },
                    {
                      fullimage: "assets/img/screenshots/lrg/wefewfwe.jpg",
                      screenshot: "assets/img/screenshots/lrg/wefewfwe.jpg",
                    },
                    {
                      fullimage: "assets/img/screenshots/lrg/vcxxcv.jpg",
                      screenshot: "assets/img/screenshots/lrg/vcxxcv.jpg",
                    },
                    {
                      fullimage: "assets/img/screenshots/lrg/nbnbv.jpg",
                      screenshot: "assets/img/screenshots/lrg/nbnbv.jpg",
                    },
                  ]}
                  gallery="UPDATE 6/20/2020"
                />

              </div>
            </>,
          ]}
          images={[]}
          style={{
            backgroundColor: "rgba(75, 82, 101, 1)",
            opacity: "0.6",
          }}
        />
      </React.Fragment>
    );
  }
}

export default arthurcashorig
